import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../locales/en.json';
import nl from '../locales/nl.json';
import es from '../locales/es.json';

const LANGUAGES = ['en', 'nl', 'es'];

const initI18n = () => {
  i18next
    .use(LanguageDetector)
    .init({
      resources: {
        en: { translation: en },
        nl: { translation: nl },
        es: { translation: es }
      },
      supportedLngs: LANGUAGES,
      load: 'languageOnly',
      fallbackLng: 'en',
      detection: {
        order: ['querystring', 'localStorage', 'navigator'],
        lookupQuerystring: 'lang',
        lookupLocalStorage: 'i18nextLng',
        caches: ['localStorage']
      }
    })
    .then(() => {
      updateContent();
      updateLanguageToggle();
      bindToggle();
    });
};

const updateContent = () => {
  document.querySelectorAll('[data-i18n]').forEach((element) => {
    const key = element.getAttribute('data-i18n');
    element.textContent = i18next.t(key);
  });

  document.querySelectorAll('[data-i18n-html]').forEach((element) => {
    const key = element.getAttribute('data-i18n-html');
    element.innerHTML = i18next.t(key);
  });

  document.querySelectorAll('[data-i18n-placeholder]').forEach((element) => {
    const key = element.getAttribute('data-i18n-placeholder');
    element.placeholder = i18next.t(key);
  });
};

const updateLanguageToggle = () => {
  const active = i18next.resolvedLanguage;
  document.documentElement.lang = active;
  document.querySelectorAll('[data-lang]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.lang === active));
  });
};

const setLanguage = (lang) => {
  i18next.changeLanguage(lang).then(() => {
    updateContent();
    updateLanguageToggle();
  });
};

const bindToggle = () => {
  document.querySelectorAll('[data-lang]').forEach((button) => {
    button.addEventListener('click', () => setLanguage(button.dataset.lang));
  });
};

export default initI18n;
